<div class="header">{{ modal.context.title }}</div>
<div class="content">
  <form class="ui form" [formGroup]="internalMessageForm">
    <!--TITLE-->
    <div class="field required">
      <label for="title" i18n="@@article-form-title">Titel:</label>
      <input id="title" formControlName="title" type="text" name="title" placeholder="Titel" i18n="@@title">
    </div>
    <!--TEXT-->
    <div class="field required">
      <label for="text" i18n="@@internal-messages-text">Text:</label>
      <app-editor id="text" [formControl]="$any(internalMessageForm.controls.text)"></app-editor>
    </div>
    <!--EXTRA INFO-->
    <div class="field">
      <label for="extraInfo" i18n="@@internal-messages-extra-info">
        Zusätzliche Informationen (Werden in der Email separat von dem Text hervorgehoben):
      </label>
      <input formControlName="extraInfo" type="text" name="extraInfo" id="extraInfo"
             placeholder="Zusätzliche Informationen für die Mitteilung"
             i18n-placeholder="@@internal-messages-extra-info-placeholder">
    </div>
    <!--SAVED-->
    <div class="field">
      <label for="saved" i18n="@@internal-messages-save-message-title">
        Mitteilung sichern:
      </label>
      <sui-checkbox class="toggle" id="saved" formControlName="saved" i18n="@@internal-messages-save-message">
        (Dies ermöglicht ein mehrfaches Versenden der Mitteilung. Wird diese Option nicht gewählt, wird die Mitteilung
        nach dem Versenden gelöscht!)
      </sui-checkbox>
    </div>
  </form>
</div>

<div class="actions">
  <button class="ui red button" (click)="modal.deny(undefined)" i18n="@@internal-messages-create-cancel">
    Abbrechen
  </button>
  <button class="ui green button" (click)="modal.approve(submit())"
          [disabled]="internalMessageForm.invalid" i18n="@@save">
    Speichern
  </button>
</div>
